import { PublicAdoptiveParentProfile } from "../../../../types/coreApiMirror";
import { HomeStudyVerified } from "../../../homeStudyVerified";
import { LinkTo } from "../../../linkTo";
import { Inline } from "../../../text";
import GalleryTile from "../../galleryTile";
import { ProfileItem } from "./components/ProfileItem";
import { sanitizeSiteUrl } from "./utils";
import { useSocialNetworksList } from "./hooks";
import { SocialNetworkItem } from "./components";

export type FamProfileDetailsProps = PublicAdoptiveParentProfile;

export function FamProfileDetails(props: FamProfileDetailsProps) {
  const {
    adoptive_parents,
    site_urls,
    profile_book,
    video_url,
    partner_professionals,
  } = props;

  const socialNetworksList = useSocialNetworksList(site_urls);

  return (
    <GalleryTile size="lg" className="bg-white p-10 pt-16">
      <div className="mb-4">
        <h1 className="text-deco-head-2 lg:text-deco-head-1 text-left">
          {adoptive_parents.map((p, i) => (
            <span key={p.uuid}>
              {i > 0 && " & "}
              {p.first_name}
            </span>
          ))}
        </h1>
      </div>

      {/* TODO COPY */}
      <div className="my-6 grid gap-4 sm:grid-cols-2">
        <ProfileItem title={"Home Study"}>
          {props.home_study_verified && (
            <HomeStudyVerified
              className={"mr-2 inline"}
              approvedText={"Approved"}
              altText={"Home study approved"}
            />
          )}
        </ProfileItem>

        {partner_professionals && partner_professionals.length > 0 && (
          <ProfileItem title={"Adoption Professional"}>
            <span
              title={partner_professionals[0].organization_name}
              className="text-onyx"
            >
              {partner_professionals[0].organization_name}
            </span>
          </ProfileItem>
        )}

        {/* {false && ( // TODO update when exposed by api
          <ProfileItem title={"Agency/Attorney"}>Name of Attorney</ProfileItem>
        )} */}

        {site_urls.personal_site && (
          <ProfileItem title={"Personal Site"}>
            <a href={site_urls.personal_site} target="_blank" rel="noreferrer">
              {sanitizeSiteUrl(site_urls.personal_site)}
            </a>
          </ProfileItem>
        )}

        {(socialNetworksList.length > 0 ||
          (video_url && video_url.length > 0)) && (
          <ProfileItem title={"Social Media"}>
            <div className="flex flex-row items-center gap-2">
              {socialNetworksList.map((socialNetwork) => (
                <SocialNetworkItem
                  key={socialNetwork.name}
                  {...socialNetwork}
                />
              ))}
            </div>
          </ProfileItem>
        )}
      </div>

      <div className="flex flex-row gap-4">
        {profile_book?.media_url && (
          <LinkTo.External
            url={profile_book?.media_url}
            style="button"
            buttonColor="green"
            buttonStyle="secondary"
          >
            <Inline size="sm">
              <b>View Profile Book</b>
            </Inline>
          </LinkTo.External>
        )}

        <LinkTo.PairTreeApp
          style="button"
          buttonColor="green"
          buttonStyle="primary"
          className="text-body-3-medium"
        >
          <b>Start a Conversation</b>
        </LinkTo.PairTreeApp>
      </div>
    </GalleryTile>
  );
}
